<template>
  <div class="misc-wrapper">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <cg-logo />
        <h2 class="brand-text text-primary ml-1">
          {{ appName }}
        </h2>
      </b-link>

      <b-navbar-nav class="nav align-items-center ml-auto absolute-locale">
        <locale />
      </b-navbar-nav>
    </b-row>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t("pageNotAuthorized.title") }}
        </h2>
        <p class="mb-2">
          {{ $t("pageNotAuthorized.subTitle") }}
        </p>
        <b-button
          variant="primary"
          class="mb-1 mr-1 btn-sm-block"
          :to="loginRoute()"
        >
          {{ $t("button.back") }}
        </b-button>
        <b-button
          variant="danger"
          class="mb-1 btn-sm-block"
          @click="logout()"
          >{{ $t("general.logout") }}</b-button
        >
        <b-img fluid :src="imgUrl" alt="Not authorized page" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton, BRow, BNavbarNav } from "bootstrap-vue";
import CgLogo from "@core/layouts/components/Logo.vue";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser, logout } from "@/auth/utils";
import { $themeConfig } from "@themeConfig";
import Locale from "@/layouts/components/app-navbar/Locale.vue";
import useJwt from "@/auth/jwt/useJwt";
import useCallStore from "@/store-pinia/useCallStore";
import useAppStore from "@/store-pinia/useAppStore";
import useChatPartnerStore from "@/store-pinia/useChatPartnerStore";

export default {
  components: {
    BRow,
    BLink,
    BImg,
    BButton,
    BNavbarNav,
    CgLogo,
    Locale,
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/not-authorized.svg"),
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require("@/assets/images/pages/not-authorized-dark.svg");
        return this.downImg;
      }
      return this.downImg;
    },
  },
  methods: {
    loginRoute() {
      const user = JSON.parse(
        localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
      );
      const route = getHomeRouteForLoggedInUser(
        user ? "admin" : null,
        null,
        user.ability
      );
      return route;
    },
    logout() {
      this.appStore.$reset()
      this.chatPartnerStore.disconnectRoomAndMessageSocket();
      this.callStore.disposeAgent();

      logout();
      // this.$OneSignal.removeExternalUserId();
      this.$OneSignal.deleteTags(["merchantUserId", "merchantId"]);

      // Redirect to login page
      this.$router.push({ name: "login" });
    },
  },
  setup() {
    // App Name
    const { appName } = $themeConfig.app;
    const callStore = useCallStore();
    const appStore = useAppStore();
    const chatPartnerStore = useChatPartnerStore();

    return {
      appName,
      callStore,
      appStore,
      chatPartnerStore
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
